import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Form, Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import "../styles/style.scss";
import styles from "../styles/ViewRecipe.module.css";
import { UncachedImage } from "react-uncached-image";
import Fraction from "fraction.js";
import FullChatBot from "./FullChatBot";
import Tiptap from "./Tiptap";
import "../styles/Tiptap.css";
import StarRating from "./StarRating";
import TagDisplay from "./TagDisplay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faArrowLeft, 
  faEdit, 
  faUtensils, 
  faListCheck, 
  faDollarSign, 
  faChartPie, 
  faUser, 
  faClock, 
  faTag, 
  faImage,
  faComments,
  faNoteSticky,
  faCalendarPlus,
  faKitchenSet,
  faChevronDown,
  faChevronRight,
  faChevronUp
} from "@fortawesome/free-solid-svg-icons";

function ViewRecipe() {
  const { id } = useParams();
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [userIsOwner, setUserIsOwner] = useState(false);

  // Private Notes Variables
  const [showPrivateNotesModal, setShowPrivateNotesModal] = useState(false);

  const handlePrivateNotesOpenModal = () => {
    if (!isLoggedIn) {
      // Display an error message, for example:
      alert("You need to log in to access your notes.");
    } else {
      setShowPrivateNotesModal(true);
    }
  };
  const handlePrivateNotesCloseModal = () => {
    setShowPrivateNotesModal(false);
  };

  // Add to Plan Variables
  const [showAddToPlanModal, setShowAddToPlanModal] = useState(false);
  const [planMultiplier, setPlanMultiplier] = useState(1);
  const [selectedDay, setSelectedDay] = useState({ value: "None", label: "None" });
  const [selectedCourse, setSelectedCourse] = useState({ value: "Dinner", label: "Dinner" });
  const [showShoppingListConfirm, setShowShoppingListConfirm] = useState(true);
  const [isAddingToPlan, setIsAddingToPlan] = useState(false);

  const handleAddToPlanOpenModal = () => {
    if (!isLoggedIn) {
      alert("You need to log in to add recipes to your plan.");
    } else {
      // Close all Bootstrap dropdowns
      const dropdowns = document.querySelectorAll('.dropdown-menu.show');
      dropdowns.forEach(dropdown => {
        dropdown.classList.remove('show');
      });
      
      // Also close dropdown toggles
      const toggles = document.querySelectorAll('.dropdown-toggle');
      toggles.forEach(toggle => {
        toggle.classList.remove('show');
        if (toggle.getAttribute('aria-expanded') === 'true') {
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
      
      // Close any Bootstrap dropdown instances
      if (window.bootstrap && window.bootstrap.Dropdown) {
        const dropdownElementList = document.querySelectorAll('.dropdown-toggle');
        dropdownElementList.forEach(dropdownToggle => {
          const dropdown = window.bootstrap.Dropdown.getInstance(dropdownToggle);
          if (dropdown) {
            dropdown.hide();
          }
        });
      }
      
      // Clear any active element focus
      if (document.activeElement) {
        document.activeElement.blur();
      }
      
      // Small delay to ensure dropdowns are fully closed
      setTimeout(() => {
        setShowAddToPlanModal(true);
      }, 100);
    }
  };
  
  const handleAddToPlanCloseModal = () => {
    setShowAddToPlanModal(false);
    // Reset values
    setPlanMultiplier(1);
    setSelectedDay({ value: "None", label: "None" });
    setSelectedCourse({ value: "Dinner", label: "Dinner" });
    setShowShoppingListConfirm(true);
  };

  const updateNotesContent = (updatedContent) => {
    setNotesContent(updatedContent);
  };

  // Holding the notes content state
  const [notesContent, setNotesContent] = useState("");


  const handlePrivatelSaveNotes = () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/private_recipe_notes_save`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        recipe_id: recipeData.id,
        updatedNotes: notesContent,
      }),
    }).then((response) => {
      handlePrivateNotesCloseModal();
      if (!response.ok) {
        // Handle error
      }
    });
  };

  // Public Notes Variables
  const [showPublicNotesModal, setShowPublicNotesModal] = useState(false);

  const handlePublicNotesOpenModal = () => {
    setShowPublicNotesModal(true);
  };

  const handlePublicNotesCloseModal = () => {
    setShowPublicNotesModal(false);
  };

  // Prep List Modal Variables
  const [showPrepListModal, setShowPrepListModal] = useState(false);
  const [collapsedPrepSections, setCollapsedPrepSections] = useState({});

  const handlePrepListOpenModal = () => {
    setShowPrepListModal(true);
  };

  const handlePrepListCloseModal = () => {
    setShowPrepListModal(false);
  };
  
  const togglePrepSection = (prepType) => {
    setCollapsedPrepSections(prev => ({
      ...prev,
      [prepType]: !prev[prepType]
    }));
  };

  const updatePublicNotesContent = (updatedContent) => {
    setPublicNotesContent(updatedContent);
  };

  // Holding the notes content state
  const [publicNotesContent, setPublicNotesContent] = useState("");

  const handlePublicSaveNotes = () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/public_recipe_notes`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        recipe_id: recipeData.id,
        updatedNotes: publicNotesContent,
      }),
    }).then((response) => {
      handlePublicNotesCloseModal();
      if (!response.ok) {
        // Handle error
      }
    });
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/isLoggedIn`, {
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.isLoggedIn) {
          setIsLoggedIn(true);
        } else {
          throw new Error("User is not logged in");
        }
      })
      .catch((error) => {
        console.error("Error checking if user is logged in:", error);
        setIsLoggedIn(false);
      });
  }, [id]);

  const [hasGold, setHasGold] = useState(false);
  const [hasSilver, setHasSilver] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/gold`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        if (response.ok) {
          setHasGold(true);
          setHasSilver(true);
          console.log("Gold");
        } else if (response.status === 403) {
          console.log("Not authorized");
          setHasGold(false);
        } else {
          console.log("Error");
          setHasGold(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setHasGold(false);
      });
  }, [id]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/silver`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        if (response.ok) {
          setHasSilver(true);
          console.log("Silver");
        } else if (response.status === 403) {
          console.log("Not authorized");
          setHasSilver(false);
        } else {
          console.log("Error");
          setHasSilver(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setHasSilver(false);
      });
  }, [id]);

  //Chatbot
  const [closeChat, setCloseChat] = useState(false);

  function toggleCloseChat() {
    if (!hasSilver) {
      alert("A Silver subscription is required for this feature");
      return;
    }

    // Toggle closeChat only if hasSilver is true
    setCloseChat(!closeChat);
  }

  const toggleClearChat = async () => {
    const confirmed = window.confirm(
      `Are you sure you want to delete the chat history? You cannot undo?`
    );

    if (!confirmed) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/delete-chat-history`,
        {
          method: "DELETE",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id }), // Send recipeId in the request body
        }
      );

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      setCloseChat(!closeChat);
    } catch (error) {
      console.error(error);
    }
  };

  //
  const navigate = useNavigate();
  const [recipeData, setRecipeData] = useState("");
  const [isMetric, setIsMetric] = useState(false); // Initialize with false instead of undefined
  const [currentUser, setCurrentUser] = useState("");
  const [isPublic, setIsPublic] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [urlName, setUrlName] = useState("");
  const [recipeRating, setRecipeRating] = useState(null);
  const [collapsedSections, setCollapsedSections] = useState({});

  const fetchRecipeData = (id) => {
    fetch(
      `${process.env.REACT_APP_API_URL}/recipes/user-check-or-default/${id}`,
      {
        credentials: "include",
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setRecipeData(data);
        setPublicNotesContent(data.public_notes);
        setRecipeRating(data.rating);
      })
      .catch((error) => console.error("Error retrieving recipe data:", error));
  };

  // Call fetchRecipeData with the recipe ID to fetch the data
  useEffect(() => {
    fetchRecipeData(id);
  }, [id]);

  // Close any open dropdowns when modal state changes
  useEffect(() => {
    if (showAddToPlanModal) {
      // Force close all Bootstrap dropdowns
      const dropdowns = document.querySelectorAll('.dropdown-menu.show');
      dropdowns.forEach(dropdown => {
        dropdown.classList.remove('show');
        dropdown.style.position = '';
        dropdown.style.transform = '';
        dropdown.style.top = '';
        dropdown.style.left = '';
      });
      
      // Reset dropdown toggles
      const toggles = document.querySelectorAll('.dropdown-toggle[aria-expanded="true"]');
      toggles.forEach(toggle => {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.classList.remove('show');
      });
      
      // Use Bootstrap's API if available
      if (window.bootstrap && window.bootstrap.Dropdown) {
        const dropdownElementList = document.querySelectorAll('.dropdown-toggle');
        dropdownElementList.forEach(dropdownToggle => {
          const dropdown = window.bootstrap.Dropdown.getInstance(dropdownToggle);
          if (dropdown) {
            dropdown.hide();
          }
        });
      }
    }
  }, [showAddToPlanModal]);

  const fetchPrivateNotes = (id) => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/get_private_recipe_notes/${id}`,
      {
        credentials: "include",
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data[0] && data[0].private_note !== undefined) {
          setNotesContent(data[0].private_note);
        } else {
          // Set notesContent to an empty string if private_note is undefined
          setNotesContent(null);
        }
      })
      .catch((error) => console.error("Error retrieving recipe data:", error));setNotesContent(null);
  };

  // Call fetchRecipeData with the recipe ID to fetch the data
  useEffect(() => {
    fetchPrivateNotes(id);
  }, [recipeData]);

  const fetchRecipeCreatorUser = async (id, recipeData) => {
    console.log("Editing:");
    console.log(recipeData.user_id);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/recipes/public-recipe-check/${id}?creator_user_id=${recipeData.user_id}&individual_recipe_public=${recipeData.public}&recipe_hidden=${recipeData.hidden}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const results = await response.json();

      setIsPublic(results.isPublic);
      setDisplayName(results.display_name);
      setUrlName(results.public_url_name);

      if (!isPublic) {
        // Handle error
      }
    } catch (error) {
      // Handle error
    }
  };

  const [multiplyer, setMultiplyer] = useState(1);

  // Day and Course options for Add to Plan modal
  const dayOptions = [
    { value: "None", label: "None" },
    { value: "Sunday", label: "Sunday" },
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
  ];

  const courseOptions = [
    { value: "Appetizer", label: "Appetizer" },
    { value: "Breakfast", label: "Breakfast" },
    { value: "Lunch", label: "Lunch" },
    { value: "Dinner", label: "Dinner" },
    { value: "Dessert", label: "Dessert" },
    { value: "Snack", label: "Snack" },
    { value: "Other", label: "Other" },
  ];

  //Macro
  let [totalProtein, setTotalProtein] = useState(0);
  let [totalCarbs, setTotalCarbs] = useState(0);
  let [totalFat, setTotalFat] = useState(0);
  let [totalFiber, setTotalFiber] = useState(0);
  let [totalSugar, setTotalSugar] = useState(0);
  let [totalCalories, setTotalCalories] = useState(0);
  let [totalPrice, setTotalPrice] = useState(0);

  const fetchUserMetricSetting = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/getUser`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const { user } = await response.json();

      if (!user) {
        // Handle error
      }
      setCurrentUser(user.id);
      setIsMetric(user.default_unit_of_measurement === "metric");
    } catch (error) {
      // Handle error
    }
  };

  const handleToggle = () => {
    setIsMetric(!isMetric);

    if (isLoggedIn) {
      // Make a POST request to update user's default_unit_of_measurement value
      fetch(`${process.env.REACT_APP_API_URL}/api/updateUser`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          default_unit_of_measurement: isMetric ? "traditional" : "metric",
        }),
      }).then((response) => {
        if (!response.ok) {
          // Handle error
        }
      });
    } else {
      console.log("Not Logged In");
    }
  };

  const [recipeIngredients, setRecipeIngredients] = useState([]);
  const [recipeInstructions, setRecipeInstructions] = useState([]);

  const toggleSection = (sectionId) => {
    setCollapsedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const fetchRecipeIngredients = (id) => {
    const unitType = isMetric ? "metric" : "traditional";
    console.log(`fetchRecipeIngredients Is Metric: ${isMetric}`);

    fetch(
      `${process.env.REACT_APP_API_URL}/api/recipe/ingredients/${id}?unitType=${unitType}`,
      {
        credentials: "include",
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("Recipe ingredients data:", data);
        // Debug prep types
        data.forEach(ing => {
          if (ing.needs_prep === 1 || (ing.needs_prep === null && ing.default_needs_prep === 1)) {
            console.log(`Ingredient: ${ing.name}, prep_type: ${ing.prep_type}, default_prep_type: ${ing.default_prep_type}, final: ${ing.prep_type || ing.default_prep_type || 'chop'}`);
          }
        });
        console.log(data);
        setRecipeIngredients(data);

        const totalProtein = data.reduce(
          (accumulator, currentValue) =>
            accumulator + parseFloat(currentValue.protein),
          0
        );
        const totalCarbs = data.reduce(
          (accumulator, currentValue) =>
            accumulator + parseFloat(currentValue.carbs),
          0
        );
        const totalFat = data.reduce(
          (accumulator, currentValue) =>
            accumulator + parseFloat(currentValue.fat),
          0
        );
        const totalFiber = data.reduce(
          (accumulator, currentValue) =>
            accumulator + parseFloat(currentValue.fiber),
          0
        );

        const totalSugar = data.reduce(
          (accumulator, currentValue) =>
            accumulator + parseFloat(currentValue.sugar),
          0
        );
        const totalCalories = data.reduce(
          (accumulator, currentValue) =>
            accumulator + parseFloat(currentValue.calories),
          0
        );
        const totalPrice = data.reduce(
          (accumulator, currentValue) =>
            accumulator + parseFloat(currentValue.price),
          0
        );

        setTotalProtein(totalProtein);
        setTotalCarbs(totalCarbs);
        setTotalFat(totalFat);
        setTotalFiber(totalFiber);
        setTotalSugar(totalSugar);
        setTotalCalories(totalCalories);
        setTotalPrice(totalPrice);
      });
  };

  const fetchRecipeInstructions = (id) => {
    fetch(`${process.env.REACT_APP_API_URL}/api/recipe/instructions/${id}`, {
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setRecipeInstructions(data);
      });
  };

  // New Qty:
  const handleNewMultiplyer = (multiplyerQty) => {
    if (!isNaN(multiplyerQty)) {
      setMultiplyer(multiplyerQty);
    } else {
      setMultiplyer("");
    }
  };

  const handleBackClick = () => {
    if (
      document.referrer &&
      document.referrer.startsWith(window.location.origin)
    ) {
      navigate(-1);
    } else {
      navigate("/recipes", { replace: true });
    }
  };

  const handleRatingChange = async (newRating) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/recipes/${id}`,
        {
          method: "PUT",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: recipeData.name,
            course: recipeData.course,
            servings: recipeData.servings,
            serving_size: recipeData.serving_size,
            tags: recipeData.tags,
            description: recipeData.description,
            rating: newRating,
          }),
        }
      );

      if (response.ok) {
        setRecipeRating(newRating);
        setRecipeData({ ...recipeData, rating: newRating });
      } else {
        throw new Error("Failed to update rating");
      }
    } catch (error) {
      console.error("Error updating rating:", error);
      throw error;
    }
  };

  const handleAddToPlan = async () => {
    if (isAddingToPlan) return; // Prevent double-clicking
    
    setIsAddingToPlan(true);
    
    try {
      // Add recipe to weekly plan
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/add-weekly-plan-recipe`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            recipe_id: recipeData.id,
            servings: recipeData.servings,
            day: selectedDay.value,
            meal: selectedCourse.value,
            meal_qty: planMultiplier,
          }),
        }
      );

      if (!response.ok) {
        if (response.status === 403) {
          alert(
            "You've reached the maximum number of recipe instances allowed for your membership level. Please upgrade your membership to add more."
          );
        } else {
          throw new Error("Error adding recipe to weekly plan");
        }
        return;
      }

      // Add to shopping list if checkbox is checked
      if (showShoppingListConfirm) {
        const ingredientsResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/api/recipe/ingredients/${recipeData.id}`,
          {
            credentials: "include",
          }
        );
        const ingredientsData = await ingredientsResponse.json();

        // Add each ingredient to shopping list
        for (const ingredient of ingredientsData) {
          const ingredientId = ingredient.old_id.split(",")[0];
          const customIngredientFlag = ingredient.old_id.includes("user") ? 1 : 0;

          await fetch(`${process.env.REACT_APP_API_URL}/api/add-shopping-item`, {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              ingredient_id: ingredientId,
              custom_ingredient: customIngredientFlag,
              qty: planMultiplier * ingredient.qty * ingredient.conversion_factor,
              day: selectedDay.value,
              meal: selectedCourse.value,
              for_recipe: recipeData.id,
              original_id_string: ingredient.old_id,
            }),
          });
        }
      }

      alert("Recipe added to your weekly plan!");
      handleAddToPlanCloseModal();
    } catch (error) {
      console.error("Error adding recipe to weekly plan:", error);
      alert("Error adding recipe to plan. Please try again.");
    } finally {
      setIsAddingToPlan(false);
    }
  };

  const isUserRecipeOwner = () => {
    if (recipeData && currentUser && recipeData.user_id === currentUser) {
      console.log(`Recipe Data: ${recipeData.user_id}`);
      console.log(`Current user: ${currentUser}`);
      setUserIsOwner(true);
      console.log(userIsOwner);
    }
  };

  useEffect(() => {
    // Fetch ingredients
    isUserRecipeOwner();
  }, [recipeData, currentUser]);

  useEffect(() => {
    // Fetch ingredients
    fetchRecipeCreatorUser(id, recipeData);
    fetchRecipeInstructions(id);
  }, [recipeData]);

  useEffect(() => {
    // Fetch ingredients
    fetchRecipeIngredients(id);
    fetchUserMetricSetting();
    console.log(`current metric ${isMetric}`);
  }, [isMetric]);

  // if (!isLoggedIn) {
  //   return (
  //     <h3>
  //       Please{" "}
  //       <a className="btn btn-primary" href={`/signin?returnUrl=${encodeURIComponent(window.location.pathname)}`}>
  //         Sign In
  //       </a>{" "}
  //       to view
  //     </h3>
  //   );
  // }

  if (!isPublic) {
    return <div>This user currently does not have their recipes public.</div>;
  }

  return (
    <div className={styles.recipeContainer}>
      <div className={styles.chatbotWidget}>
        {closeChat ? (
          <>
            <div className={styles.chatControls}>
              <Button
                variant="primary"
                onClick={toggleCloseChat}
              >
                Close
              </Button>
              <Button
                variant="danger"
                onClick={toggleClearChat}
              >
                Clear Chat
              </Button>
            </div>
            <FullChatBot
              recipeIngredients={recipeIngredients}
              recipeData={recipeData}
              recipeInstructions={recipeInstructions}
            />
          </>
        ) : (
          <div className={styles.chatbotTab} onClick={toggleCloseChat}>
            <FontAwesomeIcon icon={faComments} /> Chat with Remy
          </div>
        )}
      </div>

      <div className={styles.recipeHeader}>
        <div className={styles.headerContent}>
          <Button 
            className={styles.backButton}
            onClick={handleBackClick}
          >
            <FontAwesomeIcon icon={faArrowLeft} /> Back
          </Button>
          
          <div className={styles.headerControls}>
            <div className={styles.multiplierControl}>
              <label>Multiplier:</label>
              <input
                type="number"
                min="0.1"
                step="0.1"
                value={multiplyer}
                onChange={(e) =>
                  handleNewMultiplyer(parseFloat(e.target.value))
                }
              />
            </div>
            
            <div className={styles.metricToggle}>
              <Form.Switch
                type="switch"
                id="metric-switch"
                label="Use Metric"
                checked={isMetric}
                onChange={handleToggle}
              />
            </div>
            
            {isLoggedIn && (
              <Button
                variant="success"
                className={styles.addToPlanButton}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  
                  // Immediately close all Bootstrap dropdowns
                  const dropdowns = document.querySelectorAll('.dropdown-menu.show');
                  dropdowns.forEach(dropdown => {
                    dropdown.classList.remove('show');
                  });
                  
                  handleAddToPlanOpenModal();
                }}
              >
                <FontAwesomeIcon icon={faCalendarPlus} /> Add to Plan
              </Button>
            )}
            
            {recipeData.user_id === currentUser && (
              <Button
                className={styles.editButton}
                onClick={() =>
                  (window.location.href = `${process.env.REACT_APP_CLIENT_URL}/edit-recipe/${id}`)
                }
              >
                <FontAwesomeIcon icon={faEdit} /> Edit Recipe
              </Button>
            )}
          </div>
        </div>
      </div>
      {/* Recipe Title Section */}
      <div className={styles.recipeTitle}>
        <h1>{recipeData.name}</h1>
        <div className={styles.recipeMeta}>
          {recipeData.course && (
            <div className={styles.metaItem}>
              <FontAwesomeIcon icon={faUtensils} />
              <span>{recipeData.course}</span>
            </div>
          )}
          <div className={styles.metaItem}>
            <FontAwesomeIcon icon={faClock} />
            <span>{recipeData.servings} servings</span>
          </div>
          {recipeData.tags && (
            <div className={styles.metaItem}>
              <FontAwesomeIcon icon={faTag} />
              <TagDisplay 
                tags={recipeData.tags} 
                maxDisplay={8}
              />
            </div>
          )}
          <div className={styles.metaItem}>
            <StarRating
              rating={recipeRating}
              editable={userIsOwner}
              onChange={handleRatingChange}
              size="1.2em"
            />
          </div>
        </div>
      </div>

      {/* Main Content Grid */}
      <div className={styles.contentGrid}>
        {/* Left Column - Recipe Information */}
        <div className={styles.card}>
          <h3><FontAwesomeIcon icon={faListCheck} /> Details</h3>
          
          <div className={styles.infoCard}>
            <div className={styles.infoLabel}>Author</div>
            <div className={styles.infoValue}>
              <a href={`${process.env.REACT_APP_CLIENT_URL}/recipes/${urlName}`}>
                {displayName}
              </a>
            </div>
          </div>

          {recipeData.description && (
            <div className={styles.infoCard}>
              <div className={styles.infoLabel}>Description</div>
              <div className={styles.infoValue}>{recipeData.description}</div>
            </div>
          )}

          {recipeData.serving_size && (
            <div className={styles.infoCard}>
              <div className={styles.infoLabel}>Serving Size</div>
              <div className={styles.infoValue}>{recipeData.serving_size}</div>
            </div>
          )}

          <div className={styles.infoCard}>
            <div className={styles.infoLabel}>Detailed Nutrition (per serving)</div>
            <div className={styles.infoValue}>
              Protein: {parseFloat(totalProtein / recipeData.servings).toFixed(1)}g |
              Carbs: {parseFloat(totalCarbs / recipeData.servings).toFixed(1)}g |
              Fat: {parseFloat(totalFat / recipeData.servings).toFixed(1)}g |
              Fiber: {parseFloat(totalFiber / recipeData.servings).toFixed(1)}g |
              Sugar: {parseFloat(totalSugar / recipeData.servings).toFixed(1)}g
            </div>
          </div>
        </div>

        {/* Right Column - Image and Stats */}
        <div>
          {/* Recipe Image */}
          <div className={`${styles.card} ${styles.recipeImageContainer}`}>
            {recipeData.image_url ? (
              <UncachedImage
                className={styles.recipeImage}
                src={recipeData.image_url}
                alt={recipeData.name}
              />
            ) : (
              <div className={styles.noImage}>
                <div>
                  <FontAwesomeIcon icon={faImage} />
                  <p>No image available</p>
                </div>
              </div>
            )}
          </div>

          {/* Cost and Nutrition Stats */}
          <div className={styles.statsGrid}>
            <div className={`${styles.statCard} ${styles.costCard}`}>
              <h4><FontAwesomeIcon icon={faDollarSign} /> Cost</h4>
              <div className={styles.statItem}>
                <span className={styles.statLabel}>Total:</span>
                <span className={styles.statValue}>
                  ${parseFloat(totalPrice * multiplyer).toFixed(2)}
                </span>
              </div>
              <div className={styles.statItem}>
                <span className={styles.statLabel}>Per Serving:</span>
                <span className={styles.statValue}>
                  ${parseFloat((totalPrice * multiplyer) / recipeData.servings).toFixed(2)}
                </span>
              </div>
            </div>

            <div className={`${styles.statCard} ${styles.nutritionCard}`}>
              <h4><FontAwesomeIcon icon={faChartPie} /> Per Serving</h4>
              <div className={styles.statItem}>
                <span className={styles.statLabel}>Calories:</span>
                <span className={styles.statValue}>
                  {parseFloat(totalCalories / recipeData.servings).toFixed(0)}
                </span>
              </div>
              <div className={styles.statItem}>
                <span className={styles.statLabel}>P/C/F:</span>
                <span className={styles.statValue}>
                  {parseFloat(totalProtein / recipeData.servings).toFixed(0)}/
                  {parseFloat(totalCarbs / recipeData.servings).toFixed(0)}/
                  {parseFloat(totalFat / recipeData.servings).toFixed(0)}g
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Notes Section */}
      <div className={styles.notesSection}>
        <div className={styles.notesButtons}>
          <button
            className={`btn btn-outline-secondary ${styles.noteButton} ${
              publicNotesContent !== null && publicNotesContent !== "<p></p>" 
                ? styles.hasContent 
                : ""
            }`}
            onClick={handlePublicNotesOpenModal}
          >
            <FontAwesomeIcon icon={faNoteSticky} /> Recipe Notes
          </button>
          {isLoggedIn && (
            <button
              className={`btn btn-outline-primary ${styles.noteButton} ${
                notesContent !== null && notesContent !== "<p></p>" 
                  ? styles.hasContent 
                  : ""
              }`}
              onClick={handlePrivateNotesOpenModal}
            >
              <FontAwesomeIcon icon={faNoteSticky} /> My Notes
            </button>
          )}
          {recipeIngredients.some(ing => {
            const needsPrep = ing.needs_prep === 1 || (ing.needs_prep === null && ing.default_needs_prep === 1);
            if (!needsPrep) return false;
            
            // Smart prep type detection - prefer default_prep_type when prep_type is just the migration default
            let prepType;
            if (ing.prep_type && ing.prep_type !== 'chop') {
              prepType = ing.prep_type;
            } else if (ing.default_prep_type) {
              prepType = ing.default_prep_type;
            } else if (ing.prep_type) {
              prepType = ing.prep_type;
            } else {
              prepType = 'chop';
            }
            if (prepType === 'mix') {
              // For mix items, only show if they have matching colors
              return recipeIngredients.some(other => 
                other.id !== ing.id && 
                other.color_tag === ing.color_tag &&
                other.color_tag !== null &&
                other.color_tag !== ''
              );
            }
            return true;
          }) && (
            <button
              className={`btn btn-outline-warning ${styles.noteButton}`}
              onClick={handlePrepListOpenModal}
            >
              <FontAwesomeIcon icon={faKitchenSet} /> Prep List
            </button>
          )}
        </div>
      </div>
      {/* Recipe Content - Ingredients and Instructions */}
      <div className={styles.recipeContent}>
        {/* Ingredients Section */}
        <div className={`${styles.card} ${styles.ingredientsSection}`}>
          <div className={styles.sectionHeader}>
            <FontAwesomeIcon icon={faUtensils} />
            <h2>Ingredients</h2>
          </div>
          <div className="table-responsive">
            <table className={`table ${styles.table}`}>
              <tbody>
                {recipeIngredients.map((ingredient, index) => {
                  // Check if this is a section header
                  if (ingredient.is_section_header) {
                    const sectionId = `ingredient-section-${ingredient.id}`;
                    const isCollapsed = collapsedSections[sectionId] || false;
                    
                    // Find all ingredients under this section
                    let nextIndex = index + 1;
                    while (nextIndex < recipeIngredients.length && !recipeIngredients[nextIndex].is_section_header) {
                      nextIndex++;
                    }
                    const hasIngredients = nextIndex > index + 1;
                    
                    return (
                      <tr key={ingredient.id} className={styles.sectionHeaderRow}>
                        <td 
                          colSpan="2" 
                          className={hasIngredients ? styles.collapsible : ''}
                          style={{ backgroundColor: ingredient.color_tag, cursor: hasIngredients ? 'pointer' : 'default', padding: '0.5rem 0.75rem', borderLeft: '4px solid #6c757d' }}
                          onClick={() => hasIngredients && toggleSection(sectionId)}
                        >
                          {hasIngredients && (
                            <FontAwesomeIcon 
                              icon={isCollapsed ? faChevronRight : faChevronDown} 
                              className={styles.collapseIcon}
                            />
                          )}
                          {ingredient.section_name}
                        </td>
                      </tr>
                    );
                  }
                  
                  // Check if this ingredient should be hidden
                  let isHidden = false;
                  for (let i = index - 1; i >= 0; i--) {
                    if (recipeIngredients[i].is_section_header) {
                      const sectionId = `ingredient-section-${recipeIngredients[i].id}`;
                      isHidden = collapsedSections[sectionId] || false;
                      break;
                    }
                  }
                  
                  if (isHidden) {
                    return null;
                  }
                  
                  // Check if this is a text row
                  if (ingredient.is_text_row) {
                    // Calculate text row number - count non-section headers before this
                    const textRowNumber = recipeIngredients
                      .slice(0, index + 1)
                      .filter(ing => !ing.is_section_header)
                      .length;
                    
                    return (
                      <tr key={ingredient.id} className={styles.ingredientRow}>
                        <td
                          className="align-middle"
                          style={{ backgroundColor: ingredient.color_tag }}
                        >
                          <span className={styles.ingredientNumber}>
                            {textRowNumber})
                          </span>
                          <span className={styles.ingredientName}>
                            {ingredient.section_name}
                          </span>
                        </td>
                      </tr>
                    );
                  }
                  
                  // Regular ingredient row - adjust numbering to skip section headers
                  const ingredientNumber = recipeIngredients
                    .slice(0, index + 1)
                    .filter(ing => !ing.is_section_header)
                    .length;
                  
                  return (
                  <tr key={ingredient.id} className={styles.ingredientRow}>
                    <td
                      className="align-middle"
                      style={{ backgroundColor: ingredient.color_tag }}
                    >
                      <span className={styles.ingredientNumber}>
                        {ingredientNumber})
                      </span>
                      <span className={styles.ingredientQuantity}>
                        {(() => {
                          const result = parseFloat(ingredient.qty);
                          let displayValue;

                          if (isMetric && !Number.isInteger(result)) {
                            displayValue = (result * multiplyer).toFixed(2);
                          } else if (!isMetric) {
                            if (
                              (result % 1).toFixed(2) >= 0.31 &&
                              (result % 1).toFixed(2) <= 0.35
                            ) {
                              displayValue = new Fraction(
                                Math.round(3 * result * multiplyer)
                              )
                                .div(3)
                                .toFraction(true);
                            } else if (
                              (result % 1).toFixed(2) >= 0.65 &&
                              (result % 1).toFixed(2) <= 0.68
                            ) {
                              displayValue = new Fraction(
                                Math.round(3 * result * multiplyer)
                              )
                                .div(3)
                                .toFraction(true);
                            } else {
                              displayValue = new Fraction(
                                Math.round(8 * result * multiplyer)
                              )
                                .div(8)
                                .toFraction(true);
                            }
                          } else {
                            displayValue = result * multiplyer;
                          }

                          return displayValue;
                        })()}
                      </span>{" "}
                      <span className={styles.ingredientUnit}>{ingredient.unit_name}</span>{" "}
                      <span className={styles.ingredientName}>
                        {ingredient.name}
                      </span>{" "}
                      {ingredient.suffix}
                      {(ingredient.needs_prep === 1 || (ingredient.needs_prep === null && ingredient.default_needs_prep === 1)) && (
                        <OverlayTrigger
                          delay={{ hide: 150, show: 150 }}
                          overlay={(props) => (
                            <Tooltip {...props}>
                              This ingredient needs to be prepped (chopped, diced, etc.)
                            </Tooltip>
                          )}
                          placement="top"
                        >
                          <span className="ms-2 text-warning">
                            <FontAwesomeIcon icon={faKitchenSet} />
                          </span>
                        </OverlayTrigger>
                      )}
                    </td>
                  </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* Instructions Section */}
        <div className={`${styles.card} ${styles.instructionsSection}`}>
          <div className={styles.sectionHeader}>
            <FontAwesomeIcon icon={faListCheck} />
            <h2>Instructions</h2>
          </div>
          <div className="table-responsive">
            <table className={`table ${styles.table}`}>
              <tbody>
                {recipeInstructions.map((instruction, index) => {
                  // Check if this is a section header
                  if (instruction.is_section_header) {
                    const sectionId = `instruction-section-${instruction.id}`;
                    const isCollapsed = collapsedSections[sectionId] || false;
                    
                    // Find all instructions under this section
                    let nextIndex = index + 1;
                    while (nextIndex < recipeInstructions.length && !recipeInstructions[nextIndex].is_section_header) {
                      nextIndex++;
                    }
                    const hasInstructions = nextIndex > index + 1;
                    
                    return (
                      <tr key={instruction.id} className={styles.sectionHeaderRow}>
                        <td 
                          className={hasInstructions ? styles.collapsible : ''}
                          style={{ backgroundColor: instruction.color_tag, cursor: hasInstructions ? 'pointer' : 'default', padding: '0.5rem 0.75rem', borderLeft: '4px solid #6c757d' }}
                          onClick={() => hasInstructions && toggleSection(sectionId)}
                        >
                          {hasInstructions && (
                            <FontAwesomeIcon 
                              icon={isCollapsed ? faChevronRight : faChevronDown} 
                              className={styles.collapseIcon}
                            />
                          )}
                          {instruction.section_name}
                        </td>
                      </tr>
                    );
                  }
                  
                  // Check if this instruction should be hidden
                  let isHidden = false;
                  for (let i = index - 1; i >= 0; i--) {
                    if (recipeInstructions[i].is_section_header) {
                      const sectionId = `instruction-section-${recipeInstructions[i].id}`;
                      isHidden = collapsedSections[sectionId] || false;
                      break;
                    }
                  }
                  
                  if (isHidden) {
                    return null;
                  }
                  
                  // Regular instruction row - adjust numbering to skip section headers
                  const instructionNumber = recipeInstructions
                    .slice(0, index + 1)
                    .filter(inst => !inst.is_section_header)
                    .length;
                  
                  return (
                  <tr key={instruction.id} className={styles.instructionRow}>
                    <td
                      className="align-middle"
                      style={{ backgroundColor: instruction.color_tag }}
                    >
                      <span className={styles.instructionNumber}>
                        {instructionNumber})
                      </span>
                      <span className={styles.instructionText}>
                        {instruction.instruction}
                      </span>
                    </td>
                  </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* Modals */}
      <Modal
        show={showPrivateNotesModal}
        onHide={handlePrivateNotesCloseModal}
        size="lg"
        className={styles.notesModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon={faNoteSticky} /> Edit Personal Notes
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tiptap
            initialContent={notesContent}
            onUpdateContent={updateNotesContent}
            editingStatus={true}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handlePrivateNotesCloseModal}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={handlePrivatelSaveNotes}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showPublicNotesModal}
        onHide={handlePublicNotesCloseModal}
        size="lg"
        className={styles.notesModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon={faNoteSticky} /> Edit General Notes
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tiptap
            initialContent={publicNotesContent}
            onUpdateContent={updatePublicNotesContent}
            editingStatus={userIsOwner}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handlePublicNotesCloseModal}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={handlePublicSaveNotes}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Prep List Modal */}
      <Modal
        show={showPrepListModal}
        onHide={handlePrepListCloseModal}
        size="lg"
        className={styles.prepListModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon={faKitchenSet} /> Prep List
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted mb-3">These ingredients need to be prepped before cooking:</p>
          {(() => {
            // Function to find section name for an ingredient
            const findSectionName = (ingredient) => {
              const ingredientIndex = recipeIngredients.findIndex(ing => ing.id === ingredient.id);
              // Look backwards for the nearest section header
              for (let i = ingredientIndex - 1; i >= 0; i--) {
                if (recipeIngredients[i].is_section_header) {
                  return recipeIngredients[i].section_name;
                }
              }
              return null;
            };
            
            // Group ingredients by prep type
            const prepItems = recipeIngredients.filter(ing => ing.needs_prep === 1 || (ing.needs_prep === null && ing.default_needs_prep === 1));
            
            // For mix items, check if they have matching colors with other ingredients
            const filteredPrepItems = prepItems.filter(ingredient => {
              // Smart prep type detection - prefer default_prep_type when prep_type is just the migration default
              let prepType;
              if (ingredient.prep_type && ingredient.prep_type !== 'chop') {
                prepType = ingredient.prep_type;
              } else if (ingredient.default_prep_type) {
                prepType = ingredient.default_prep_type;
              } else if (ingredient.prep_type) {
                prepType = ingredient.prep_type;
              } else {
                prepType = 'chop';
              }
              if (prepType === 'mix') {
                // Check if any other ingredient in the recipe has the same color
                return recipeIngredients.some(other => 
                  other.id !== ingredient.id && 
                  other.color_tag === ingredient.color_tag &&
                  other.color_tag !== null &&
                  other.color_tag !== ''
                );
              }
              return true; // Include all non-mix items
            });
            
            const groupedByType = filteredPrepItems.reduce((groups, ingredient) => {
              // Use prep_type only if it's explicitly set (not null)
              // This avoids using 'chop' from the migration when default_prep_type is something else
              let prepType;
              if (ingredient.prep_type && ingredient.prep_type !== 'chop') {
                // Use recipe-specific override if it's not the default migration value
                prepType = ingredient.prep_type;
              } else if (ingredient.default_prep_type) {
                // Use the ingredient's default prep type
                prepType = ingredient.default_prep_type;
              } else if (ingredient.prep_type) {
                // Fall back to prep_type even if it's 'chop'
                prepType = ingredient.prep_type;
              } else {
                // Final fallback
                prepType = 'chop';
              }
              
              if (!groups[prepType]) {
                groups[prepType] = [];
              }
              groups[prepType].push(ingredient);
              return groups;
            }, {});
            
            const typeLabels = {
              chop: 'Chop',
              mix: 'Mix',
              measure: 'Measure',
              other: 'Other'
            };
            
            // Define the order of prep types
            const prepTypeOrder = ['chop', 'mix', 'measure', 'other'];
            
            // Sort entries by the defined order
            const sortedEntries = Object.entries(groupedByType).sort(([a], [b]) => {
              const indexA = prepTypeOrder.indexOf(a);
              const indexB = prepTypeOrder.indexOf(b);
              return indexA - indexB;
            });
            
            return sortedEntries.map(([prepType, ingredients]) => {
              // For mix items, group by color
              if (prepType === 'mix') {
                const colorGroups = ingredients.reduce((groups, ingredient) => {
                  const color = ingredient.color_tag || 'no-color';
                  if (!groups[color]) {
                    groups[color] = [];
                  }
                  groups[color].push(ingredient);
                  return groups;
                }, {});
                
                // Filter out color groups that have only one ingredient
                // We need at least 2 ingredients with the same color to mix
                const validColorGroups = Object.entries(colorGroups).filter(([color, colorIngredients]) => {
                  return colorIngredients.length >= 2;
                });
                
                // If no valid color groups, skip this prep type
                if (validColorGroups.length === 0) {
                  return null;
                }
                
                return (
                  <div key={prepType} className="mb-4">
                    <div 
                      className="prep-type-header text-uppercase text-muted mb-2 d-flex align-items-center justify-content-between px-3 py-2 rounded"
                      onClick={() => togglePrepSection(prepType)}
                      style={{ 
                        cursor: 'pointer', 
                        userSelect: 'none',
                        backgroundColor: '#f8f9fa',
                        fontWeight: '600',
                        fontSize: '0.9rem',
                        letterSpacing: '0.5px'
                      }}
                    >
                      <span>{typeLabels[prepType] || prepType}</span>
                      <FontAwesomeIcon 
                        icon={collapsedPrepSections[prepType] ? faChevronDown : faChevronUp}
                        size="sm"
                      />
                    </div>
                    <div style={{ 
                      maxHeight: collapsedPrepSections[prepType] ? '0' : '1000px',
                      overflow: 'hidden',
                      transition: 'max-height 0.3s ease-in-out'
                    }}>
                      {validColorGroups.map(([color, colorIngredients]) => (
                        <div key={color} className="mb-3">
                          <ul className="list-unstyled">
                            {colorIngredients.map((ingredient) => (
                              <li key={ingredient.id} className="mb-3 d-flex align-items-start">
                                <div className="d-flex align-items-start">
                                  <div 
                                    className="color-indicator me-2 mt-1" 
                                    style={{ 
                                      width: '12px', 
                                      height: '12px', 
                                      backgroundColor: color !== 'no-color' ? color : '#ccc',
                                      borderRadius: '2px',
                                      border: '1px solid #ddd'
                                    }}
                                    title={color !== 'no-color' ? 'Mix items with this color together' : 'No color assigned'}
                                  />
                                  <FontAwesomeIcon icon={faKitchenSet} className="text-warning mt-1 me-2" />
                                  <div>
                                    <strong>
                      {(() => {
                        const result = parseFloat(ingredient.qty) * multiplyer;
                        let displayValue;

                        if (isMetric && !Number.isInteger(result)) {
                          displayValue = result.toFixed(2);
                        } else if (!isMetric) {
                          if (
                            (result % 1).toFixed(2) >= 0.31 &&
                            (result % 1).toFixed(2) <= 0.35
                          ) {
                            displayValue = new Fraction(Math.round(3 * result))
                              .div(3)
                              .toFraction(true);
                          } else if (
                            (result % 1).toFixed(2) >= 0.65 &&
                            (result % 1).toFixed(2) <= 0.68
                          ) {
                            displayValue = new Fraction(Math.round(3 * result))
                              .div(3)
                              .toFraction(true);
                          } else {
                            displayValue = new Fraction(Math.round(8 * result))
                              .div(8)
                              .toFraction(true);
                          }
                        } else {
                          displayValue = result;
                        }

                        return displayValue;
                      })()}
                    </strong>{" "}
                                    {ingredient.unit_name} {ingredient.name} {ingredient.suffix}
                                    {(() => {
                                      const sectionName = findSectionName(ingredient);
                                      return sectionName ? <span className="text-info"> ({sectionName})</span> : null;
                                    })()}
                                  </div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              }
              
              // Regular prep types (non-mix)
              return (
                <div key={prepType} className="mb-4">
                  <div 
                    className="prep-type-header text-uppercase text-muted mb-2 d-flex align-items-center justify-content-between px-3 py-2 rounded"
                    onClick={() => togglePrepSection(prepType)}
                    style={{ 
                      cursor: 'pointer', 
                      userSelect: 'none',
                      backgroundColor: '#f8f9fa',
                      fontWeight: '600',
                      fontSize: '0.9rem',
                      letterSpacing: '0.5px'
                    }}
                  >
                    <span>{typeLabels[prepType] || prepType}</span>
                    <FontAwesomeIcon 
                      icon={collapsedPrepSections[prepType] ? faChevronDown : faChevronUp}
                      size="sm"
                    />
                  </div>
                  <div style={{ 
                    maxHeight: collapsedPrepSections[prepType] ? '0' : '1000px',
                    overflow: 'hidden',
                    transition: 'max-height 0.3s ease-in-out'
                  }}>
                    <ul className="list-unstyled">
                      {ingredients.map((ingredient) => (
                        <li key={ingredient.id} className="mb-3 d-flex align-items-start">
                          <FontAwesomeIcon icon={faKitchenSet} className="text-warning mt-1 me-2" />
                          <div>
                            <strong>
                              {(() => {
                                const result = parseFloat(ingredient.qty) * multiplyer;
                                let displayValue;

                                if (isMetric && !Number.isInteger(result)) {
                                  displayValue = result.toFixed(2);
                                } else if (!isMetric) {
                                  if (
                                    (result % 1).toFixed(2) >= 0.31 &&
                                    (result % 1).toFixed(2) <= 0.35
                                  ) {
                                    displayValue = new Fraction(Math.round(3 * result))
                                      .div(3)
                                      .toFraction(true);
                                  } else if (
                                    (result % 1).toFixed(2) >= 0.65 &&
                                    (result % 1).toFixed(2) <= 0.68
                                  ) {
                                    displayValue = new Fraction(Math.round(3 * result))
                                      .div(3)
                                      .toFraction(true);
                                  } else {
                                    displayValue = new Fraction(Math.round(8 * result))
                                      .div(8)
                                      .toFraction(true);
                                  }
                                } else {
                                  displayValue = result;
                                }

                                return displayValue;
                              })()}
                            </strong>{" "}
                            {ingredient.unit_name} {ingredient.name} {ingredient.suffix}
                            {(() => {
                              const sectionName = findSectionName(ingredient);
                              return sectionName ? <span className="text-info"> ({sectionName})</span> : null;
                            })()}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              );
            }).filter(Boolean); // Remove any null entries (mix sections with only 1 item)
          })()}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handlePrepListCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add to Plan Modal */}
      <Modal
        show={showAddToPlanModal}
        onHide={handleAddToPlanCloseModal}
        size="lg"
        className={styles.addToPlanModal}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon={faCalendarPlus} /> Add {recipeData.name} to Weekly Plan
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Recipe Information */}
            <div className="mb-3 p-3 bg-light rounded">
              <h6 className="mb-2">Recipe Details</h6>
              <div className="d-flex justify-content-between">
                <span><strong>Recipe:</strong> {recipeData.name}</span>
                <span><strong>Base Servings:</strong> {recipeData.servings}</span>
              </div>
            </div>

            {/* Multiplier */}
            <Form.Group className="mb-3">
              <Form.Label>Multiplier</Form.Label>
              <div className="d-flex align-items-center">
                <Form.Control
                  type="number"
                  min="0.1"
                  step="0.1"
                  value={planMultiplier}
                  onChange={(e) => setPlanMultiplier(parseFloat(e.target.value) || 1)}
                  style={{ width: "100px", marginRight: "10px" }}
                />
                <span className="text-muted">
                  = {((planMultiplier || 1) * (recipeData.servings || 1)).toFixed(1)} total servings
                </span>
              </div>
            </Form.Group>

            {/* Day Selection */}
            <Form.Group className="mb-3">
              <Form.Label>Day</Form.Label>
              <Select
                value={selectedDay}
                onChange={setSelectedDay}
                options={dayOptions}
                className="react-select-container"
                classNamePrefix="react-select"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: base => ({ ...base, zIndex: 9999 })
                }}
              />
            </Form.Group>

            {/* Course Selection */}
            <Form.Group className="mb-3">
              <Form.Label>Course</Form.Label>
              <Select
                value={selectedCourse}
                onChange={setSelectedCourse}
                options={courseOptions}
                className="react-select-container"
                classNamePrefix="react-select"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: base => ({ ...base, zIndex: 9999 })
                }}
              />
            </Form.Group>

            {/* Shopping List Checkbox */}
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                id="shopping-list-checkbox"
                label="Add ingredients to shopping list"
                checked={showShoppingListConfirm}
                onChange={(e) => setShowShoppingListConfirm(e.target.checked)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleAddToPlanCloseModal}>
            Cancel
          </Button>
          <Button 
            variant="success" 
            onClick={handleAddToPlan}
            disabled={isAddingToPlan}
          >
            {isAddingToPlan ? "Adding..." : "Add to Plan"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ViewRecipe;
